import type { ErrorCode } from '../schemas/errors.ts';

/**
 * Participant-facing error copy, verbatim from docs/03_MOBILE_UI_SPEC.md §25.
 *
 * The API sends these in `ErrorResponse.message` and the client shows the same
 * strings, so a participant and a support log never disagree about what
 * happened. Do not reword: the copy was signed off with the spec.
 */
export const ERROR_MESSAGES_VI: Record<ErrorCode, string> = {
  INVALID_REQUEST: 'Thông tin chưa hợp lệ. Vui lòng kiểm tra lại.',
  EVENT_NOT_FOUND: 'Không tìm thấy sự kiện.',
  EVENT_NOT_ACTIVE: 'Sự kiện hiện không nhận check-in.',
  INVALID_LOCATION: 'Địa điểm không hợp lệ. Vui lòng chọn lại.',
  CHECKOUT_NOT_ENABLED: 'Sự kiện này không ghi nhận giờ check-out.',
  // Admin-only: a participant never sees this one.
  SLUG_TAKEN: 'Đường dẫn này đã có sự kiện khác dùng. Vui lòng chọn đường dẫn khác.',
  // Reserved: the server never returns this in Phase 1 (AGENTS.md invariant 6).
  // The copy exists only so a Phase 2 server could not ship without it.
  CONFIG_VERSION_MISMATCH: 'Thông tin sự kiện đã được cập nhật. Vui lòng tải lại trang.',
  TURNSTILE_FAILED: 'Không thể xác minh yêu cầu. Vui lòng thử lại.',
  REQUEST_TOO_LARGE: 'Thông tin nhập vào quá dài. Vui lòng rút gọn.',
  TEMPORARY_UNAVAILABLE: 'Kết nối chưa ổn định. Thông tin đã được lưu trên thiết bị.',
  NOT_FOUND: 'Không tìm thấy dữ liệu.',
};

/**
 * Shown instead of the base INVALID_LOCATION copy once the client has
 * refreshed the bootstrap and found the location really is gone (§25).
 */
export const INVALID_LOCATION_AFTER_REFRESH_VI =
  'Địa điểm không còn khả dụng. Vui lòng chọn địa điểm khác.';

export function errorMessageVi(code: ErrorCode): string {
  return ERROR_MESSAGES_VI[code];
}
